<template>
    <MainContentSearchable title="Listado de categorías" id="categorias" v-model="filters" :meta="loading ? {} : categorias.meta" @updated="debouncedGetCategorias">
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de categorías</h3>
            <div class="card-tools mb-3 align-items-center">
                <router-link :to="{ name: 'back.productos.categorias.ordenar' }" class="btn btn-primary mr-2" id="ordenar-categorias">
                    Ordenar Categorías
                </router-link>
                <Button @click="showModal('crear-categoria')" class="btn btn-primary" id="crear-categoría">
                    Crear categoría
                </Button>
                <ModalCreate
                    @close="closeModal"
                />
            </div>
        </template>

        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="!loading" :class="['table', { 'expanded': categorias.data.length <= 3 }]">
                    <b-table hover :items="categorias.data" :fields="fields">
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent 
                                :lastIndex="categorias.data.length > 3 && index >= categorias.data.length - 3"
                                v-bind:options="[
                                    { type: 'action', action:() => showModal('editar-categoria', item), label: 'Editar'},
                                    { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'}
                                ]"
                            />
                            <ModalEdit
                                :categoria="categoriaSeleccionada"
                                @close="closeModal"
                            />
                            <BorrarModalComponent
                                :name="'borrar-' + item.id"
                                :title="'Borrar categoría ' + item.name"
                                confirmButton="¿Está segur@ de borrar esta categoría?"
                                @close="() => closeModal()"
                                @confirm="() => borrar(item.id)"
                            />
                        </template>
                    </b-table>
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import ModalCreate from '@/components/backend/productos/categorias/ModalCreate';
    import ModalEdit from '@/components/backend/productos/categorias/ModalEdit';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

    export default {
        data() {
            return {
                loading: false,
                categoriaSeleccionada: {},
                categorias: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [
                    { key: "name", label: "Nombre", class: 'text-center' },
                    { key: "description", label: "Descripción", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ]
            }
        },
        created() {
            this.getCategorias();
            this.debouncedGetCategorias = _.debounce(this.getCategorias, 500);
        },
        methods: {
            getCategorias() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.categorias.index'), params).then(res => {
                    this.categorias = res.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            borrar(categoria_id) {
                this.loading = true;

                let params = {
                    teatro_id: this.teatro.id,
                    category_id: categoria_id,
                    filters: {}
                };
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.categorias.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getCategorias();
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => this.loading = false);
            },
            showModal(modal, categoria) {
                this.$modal.show(modal);

                if (categoria) {
                    this.categoriaSeleccionada = categoria;
                }
            },
            closeModal(modal, reload) {
                this.$modal.hide(modal);

                if (reload) {
                    this.getCategorias();
                }
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, BorrarModalComponent, ModalCreate, ModalEdit
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>